(function () {
    'use strict';

    function questionConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/questionConfiguration.html',
            link: function (scope) {

            }
        };
    }

    questionConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('questionConfiguration', questionConfiguration);
})();
